import React from "react";
import PropTypes from "prop-types";
import * as DomainConstants from "../../constants/DomainConstants";
import ValidationGroup from "../common/ValidationGroup";
import CheckBoxWithChild from "../common/CheckBoxWithChild";
import { orderByPropertyName } from "../../util/orderBy";
import { Popup } from 'semantic-ui-react';
import Tooltip from "../common/Tooltip";


const InfrastructurenInDeBuurtTable = props => {
	const {
		infrastructurenInDeBuurt,
		disabled,
		errors
	} = props;

	const onChange = (id) => {
		return function (event) {
			return props.onChange(event, id);
		};
	};

	const onEdit = (id) => {
		return function () {
			return props.onEdit(id);
		};
	};

	function findSporttakById(id, sporttakId) {
		const selectedSoortInfrastructuur = props.soortenInfrastructuur.find(x => x.id === id);
		if (selectedSoortInfrastructuur) {
			const sporttak = selectedSoortInfrastructuur.sporttakken.find(s => s.id === sporttakId);
			if (sporttak) {
				return sporttak.naam;
			}
		}
		return "";
	}

	function findById(id) {
		const type = props.soortenInfrastructuurAll.find(x => x.id === id);
		if (type) {
			return type.description;
		}
		return "Geen Type";
	}
	const infrastructurenRows = orderByPropertyName(infrastructurenInDeBuurt, "naam").map((infrastructuur, i) => {
		const isTypeAndere = infrastructuur.soortInfrastructuurId == DomainConstants.ANDERE_INFRASTRUCTUUR_GUID
			? (<span><br />{infrastructuur.andereInfrastructuur}</span>)
			: "";


		const deelVanAanvraag = infrastructuur.deelVanAanvraag.toString() === DomainConstants.DeelVanAanvraag.Ja.toString();
		const checkboxDisabled = disabled || infrastructuur.deelVanAanvraag.toString() === DomainConstants.DeelVanAanvraag.Reconversie.toString();

		const icons = !checkboxDisabled && deelVanAanvraag ? (
			<td>
				<span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-pencil fa-fw" onClick={onEdit(infrastructuur.id)}/>} content="Wijzig infrastructuur" /></span>
			</td>) : <td/>;

		return (
			<tr key={i}>
				<td>{infrastructuur.naam}</td>
				<td>{findById(infrastructuur.soortInfrastructuurId)}{isTypeAndere}</td>
				<td>{findSporttakById(infrastructuur.soortInfrastructuurId, infrastructuur.sporttak)}</td>
				<td style={{ verticalAlign: 'center' }}>
					<CheckBoxWithChild
						name={"gerenoveerdInProject" + i}
						value={deelVanAanvraag}
						onChange={onChange(infrastructuur.id)}
						size={1}
						disabled={checkboxDisabled}
					/>
				</td>
				{icons}
			</tr>);
	});

	return (
		<ValidationGroup errors={errors ? errors : undefined}  >
			<table className="c-table hours">
				<thead>
					<tr>
						<th width={"28%"}>NAAM VAN DE INFRASTRUCTUUR</th>
						<th width={"15%"}>TYPE</th>
						<th width={"37%"}>WELKE SPORTTAK ZAL ER HOOFDZAKELIJK BEOEFEND WORDEN? <Tooltip text={"Je hoeft deze informatie enkel aan te vullen indien de sportinfrastructuur een natuur- of kunstgrasveld betreft"} /></th>
						<th width={"20%"}>WORDT GERENOVEERD IN DIT PROJECT</th>
						<th/>
					</tr>
				</thead>
				<tbody>
					{infrastructurenRows}
				</tbody>
			</table>
		</ValidationGroup>
	);
};

// ----------------------------------------------------------------------------
InfrastructurenInDeBuurtTable.propTypes = {
	infrastructurenInDeBuurt: PropTypes.arrayOf(PropTypes.object),
	errors: PropTypes.object,
	disabled: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	soortenInfrastructuur: PropTypes.array,
	soortenInfrastructuurAll: PropTypes.array,
	onEdit: PropTypes.func
};

export default InfrastructurenInDeBuurtTable;
